"use client";

import { MobileSidebarToggle } from "@/components/mobile-sidebar-toggle";
import { usePathname } from "next/navigation";

type SettingsLayoutProps = {
  children: React.ReactNode;
};

export default function SettingsLayout({ children }: SettingsLayoutProps) {
  const pathname = usePathname();

  return (
    <div className="flex h-full flex-col overflow-hidden bg-background">
      <MobileSidebarToggle layoutName="Settings" />
      <div className="lb-scrollbar-overlay flex-1 overflow-x-hidden overscroll-y-auto bg-background">
        <div
          className={`mx-auto mb-8 flex w-full max-w-5xl flex-col pt-7 sm:mb-20 ${pathname.includes("subscriptions") || pathname.includes("api-keys") ? "" : "items-center"} px-3.5 sm:px-5`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
